import { combineReducers } from 'redux';
import MarketingPlayConfigurationReducer from './MarketingPlayConfiguration/MarketingPlayConfigurationReducer';
import CommonReducer from './Common/CommonReducer';
import MarketingPlayReportsReducer from './MarketingPlayReports/MarketingPlayReportsReducer';
import AvailablePlaysReducer from './AvailablePlays/AvailablePlaysReducer';
import DatabaseOverviewReducer from './DatabaseOverview/DatabaseOverviewReducer';
import ContactabilityReducer from './Contactability/ContactabilityReducer';
import DataQualityReducer from './DataQuality/DataQualityReducer';
import DataSourceReducer from './DataSource/DataSourceReducer';
import DemographicReducer from './Demographic/DemographicReducer';
import GeographyReducer from './Geography/GeographyReducer';
import RFMReducer from './RFM/RFMReducer';
import TopAndBottomCustomerReducer from './TopAndBottomCustomer/TopAndBottomCustomerRedux';
import FileManagementReducer from './FileManagement/FileManagementReducer';
import EmailDesigner from './EmailDesigner/EmailDesigner';
import TwoFactorAuth from './TwoFactorAuth/TwoFactorAuth';
import SMSDesigner from './SMSDesigner/SMSDesigner';
import FormEditor from './FormBuilder/FormEditor';
import FormLibrary from './FormBuilder/FormLibrary';
import FormSubmissions from './FormBuilder/FormSubmissions';
import Configuration from './Configuration/Configuration';
import CustomerManagementReducer from './Customer/CustomerManagementReducer';
import Calendar from './Calendar/Calendar';
import WizardReducer from './Wizard/WizardReducer';
import DataDictionaryReducer from './DataDictionary/DataDictionaryReducer';
import PreferenceCenterReducer from './PreferenceCenter/PreferenceCenterReducer';
import BeeEditorStateReducer from './EmailDesigner/BeeEditorState';
import SurveyReducer from './Survey/SurveyReducer';


export default combineReducers({
    marketingPlayConfiguration: MarketingPlayConfigurationReducer,
    common: CommonReducer,
    marketingPlayReports: MarketingPlayReportsReducer,
    availablePlays: AvailablePlaysReducer,
    databaseOverview: DatabaseOverviewReducer,
    contactability: ContactabilityReducer,
    dataQuality: DataQualityReducer,
    dataSource: DataSourceReducer,
    dataDictionary: DataDictionaryReducer,
    preferenceCenter: PreferenceCenterReducer,
    demographic: DemographicReducer,
    geography: GeographyReducer,
    rfm: RFMReducer,
    topAndBottomCustomer: TopAndBottomCustomerReducer,
    fileManagement: FileManagementReducer,
    emailDesigner: EmailDesigner,
    twoFactorAuth: TwoFactorAuth,
    smsDesigner: SMSDesigner,
    formEditor: FormEditor,
    formLibrary: FormLibrary,
    configuration:Configuration,
    formSubmissions: FormSubmissions,
    customerManagement: CustomerManagementReducer,
    calendar: Calendar,
    wizard: WizardReducer,
    survey: SurveyReducer,


})